import { getAllByOrganizationId, getGroupsByDepartment } from "../../service/User";

export const getInventoryOrganizationIds = (items) => [...new Set(items
  .map((item) => Number(item.organizationId ?? item.raw?.organizationId ?? item.raw?.organization?.organizationId ?? item.raw?.orgId))
  .filter((id) => Number.isSafeInteger(id) && id > 0))];

// Load groups within the supplied organization, narrowing to the selected
// department when it belongs to that organization.
export const loadInventoryGroups = async (organizationId, departmentId) => {
  if (!organizationId) return [];
  const departments = await getAllByOrganizationId(organizationId);
  if (!Array.isArray(departments)) return [];
  const matchingDepartment = departments.find(
    (department) => String(department.id) === String(departmentId)
  );
  const eligible = matchingDepartment ? [matchingDepartment] : departments;
  const lists = await Promise.all(eligible.map((department) => getGroupsByDepartment(department.id)));
  return lists.flatMap((list) => Array.isArray(list) ? list : []);
};
